import { DeleteConfirmPopup } from '../../common/DeleteConfirmPopup/DeleteConfirmPopup';

import { getDeleteDraftConfirmPopupContent } from './deleteDraftConfirmPopupContent';

interface DeleteDraftConfirmPopupProps {
    isOpen: boolean;
    onSubmit: () => void;
    onDismiss: () => void;
    reference?: string;
    isSubmitting?: boolean;
}

export const DeleteDraftConfirmPopup = ({
    isOpen,
    onSubmit,
    onDismiss,
    reference,
    isSubmitting = false,
}: DeleteDraftConfirmPopupProps) => {
    const content = getDeleteDraftConfirmPopupContent(reference);

    return (
        <DeleteConfirmPopup
            isOpen={isOpen}
            onSubmit={onSubmit}
            onDismiss={onDismiss}
            headline={content.headline}
            text={content.text}
            isSubmitting={isSubmitting}
        />
    );
};
